/**
 * Tells the search box's own `?q=` writes apart from navigation.
 *
 * The box owns what is typed and the URL follows it, because the router
 * commits URL changes in a transition: an input bound straight to `?q=` showed
 * the previous value between keystrokes, and the next key was added to that,
 * dropping letters ("storage" came out as "sto"). The URL still has to flow
 * back into the box when something else changes it (Back, a link, a shared
 * URL), but its late echo of a value the box wrote must not, or an older value
 * landing mid-word would retype it.
 *
 * Writes land in order, though the router may skip straight to a later one, so
 * an echo forgets itself and every older write still pending.
 */
export function createSearchEcho() {
  let pending: string[] = []
  return {
    /** The box is writing `q` to the URL. */
    wrote(q: string) {
      pending.push(q)
    },
    /** `q` just arrived in the URL: true if it is the echo of the box's own write. */
    isEcho(q: string) {
      const i = pending.indexOf(q)
      if (i < 0) return false
      pending = pending.slice(i + 1)
      return true
    },
  }
}
